export const ClientType = {
    WEB: 'web',
    WECHAT: 'wechat'
}